import gql from 'graphql-tag'

export const QUERY_GET_CAMPAIGN_RESULTS_BY_ID = gql`
  query Campaign($id: ID!) {
    campaign(_id: $id) {
      _id
      title
      status
      description
      initial_date
      final_date
      segments {
        _id
        name
        clients_qty
        updated_at
        clients_refreshed_at
        clients_qty_at_campaign
      }
      products {
        sku
        name
      }
      units {
        id_erp
        name
      }
      ... on WhatsappChannelCampaign {
        senders {
          name
          number
        }
        targeting_mode
        messages_queues {
          queues {
            sender {
              name
              number
            }
            quantity
          }
          time
        }
      }
      message {
        text
        send_date
        send_time
        ... on WhatsappChannelCampaignMessage {
          attachment {
            mimetype
            data_url
            filename
            thumbnail_url
          }
          cancelation {
            canceled
            canceled_at
            canceled_by {
              _id
              name
            }
          }
        }
      }
    }
  }
`

export const QUERY_GET_CAMPAIGN_EDIT_BY_ID = gql`
  query CampaignEditById($id: ID!) {
    campaign(_id: $id) {
      _id
      title
      status
      description
      ... on WhatsappChannelCampaign {
        senders {
          name
          number
        }
        targeting_mode
      }
      units {
        id_erp
        name
      }
      initial_date
      final_date
      segments {
        _id
        name
        clients_qty
        updated_at
        clients_refreshed_at
      }
      products {
        sku
        name
      }
      message {
        text
        send_date
        send_time
        ... on WhatsappChannelCampaignMessage {
          attachment {
            mimetype
            data_url
            filename
            thumbnail_url
          }
        }
      }
      offers_schedule {
        _id
        name
        description
        segments
        end_date
        start_date
      }
      template_id
    }
  }
`

export const MUTATION_UPSERT_CAMPAIGN = gql`
  mutation UpsertWhatsappCampaign($data: WhatsappChannelCampaignInput!) {
    upsertWhatsappCampaign(data: $data) {
      _id
    }
  }
`

export const MUTATION_UPSERT_DRAFT_CAMPAIGN = gql`
  mutation UpsertDraftWhatsappCampaign($data: DraftWhatsappChannelCampaignInput!) {
    upsertDraftWhatsappCampaign(data: $data) {
      _id
    }
  }
`

export const MUTATION_DELETE_CAMPAIGN = gql`
  mutation DeleteCampaign($id: ID!) {
    deleteCampaign(_id: $id) {
      _id
      message
    }
  }
`

export const QUERY_NUMBER_OF_CONTACTS = gql`
  query GetNumberOfContacts($active: Boolean, $senders: [String]) {
    getNumberOfContacts(active: $active, senders: $senders) {
      total
      community_total
      loyalty
      non_loyalty
    }
  }
`

export const QUERY_NUMBER_OF_APPLICATIVES = gql`
  query GetTotalAppSegmentation {
    getTotalAppSegmentation {
      all
      logged
      non_logged
    }
  }
`

export const MUTATION_CANCEL_CAMPAIGN = gql`
  mutation CancelWhatsappSendings($id: ID!) {
    cancelWhatsappSendings(campaign_id: $id)
  }
`

export const QUERY_GET_CONTACTS = gql`
  query GetContacts(
    $page: Int
    $pageSize: Int
    $sort: [String]
    $sortDirection: [SortDirection]
    $initial_date: String
    $final_date: String
    $active: Boolean
    $senders: [String]
  ) {
    getContacts(
      page: $page
      pageSize: $pageSize
      sort: $sort
      sortDirection: $sortDirection
      initial_date: $initial_date
      final_date: $final_date
      active: $active
      senders: $senders
    ) {
      records
      page
      contacts {
        number
        client_id
        active
        loyalty
        register
        sender {
          name
          number
        }
        created_at
        updated_at
      }
    }
  }
`

export const MUTATION_EXPORT_WHATSAPP_CONTACTS_REPORT = gql`
  mutation CreateWappContactsReport($emails: [String!]!) {
    createWappContactsReport(emails: $emails) {
      fileUrl
      id
      payload {
        emails
      }
      state
    }
  }
`

export const QUERY_GET_MESSAGE_BY_TYPE = gql`
  query GetMessageByType($type: MessageType!) {
    getMessageByType(type: $type) {
      _id
      type
      text
      active
    }
  }
`

export const MUTATION_UPDATE_AUTOMATIC_REPLY_MESSAGE = gql`
  mutation UpdateMessageByType($type: MessageType!, $text: String!, $active: Boolean) {
    updateMessageByType(type: $type, text: $text, active: $active) {
      _id
      type
      text
      active
    }
  }
`

export const QUERY_GET_NUMBERS = gql`
  query GetNumbers {
    getNumbers {
      _id
      name
      number
      type
      connection_status
      nof_contacts
      nof_community_contacts
      instance_id
      public_information {
        active
        name
        description
        image
        message
        hotsite_slots {
          _id
          name
        }
      }
    }
  }
`

export const MUTATION_UPSERT_FLOW_MENU = gql`
  mutation UpsertWhatsappFlowMenu($data: WhatsappFlowMenuInput!) {
    upsertWhatsappFlowMenu(data: $data) {
      _id
    }
  }
`

export const MUTATION_UPSERT_DRAFT_FLOW_MENU = gql`
  mutation UpsertDraftWhatsappFlowMenu($data: DraftWhatsappFlowMenuInput!) {
    upsertDraftWhatsappFlowMenu(data: $data) {
      _id
    }
  }
`

export const MUTATION_DELETE_FLOW_MENU = gql`
  mutation DeleteWhatsappFlowMenu($_id: ID!) {
    deleteWhatsappFlowMenu(_id: $_id)
  }
`

export const QUERY_WHATSAPP_FLOW_MENUS = gql`
  query GetWhatsappFlowMenus(
    $search: String
    $page: Int!
    $pageSize: Int!
    $sort: [String]
    $sortDirection: [SortDirection]
    $active: Boolean
    $registers: [String]
  ) {
    whatsappFlowMenus(search: $search, page: $page, pageSize: $pageSize, sort: $sort, sortDirection: $sortDirection, active: $active, registers: $registers) {
      records
      page
      whatsappFlowMenus {
        _id
        title
        description
        active
        updated_at
        registers {
          number
          name
        }
      }
    }
  }
`

export const GET_FLOW = gql`
  query GetWhatsappFlowMenu($_id: ID!) {
    whatsappFlowMenu(_id: $_id) {
      _id
      title
      description
      message
      active
      registers {
        number
        name
      }
      menu_options {
        active
        menu_name
        flow {
          id
          handle
          ... on WhatsappFlowForwardToSender {
            forward_registers {
              units {
                name
                id_erp
              }
              number
            }

            select_federative_unit_message {
              active
              message
            }
            select_city_message {
              active
              message
            }
            select_unit_message {
              active
              message
            }
            send_contact_message
            start_register_chat_content
          }
          ... on WhatsappFlowSimpleResponse {
            message
          }
        }
      }
    }
  }
`

export const MUTATION_SET_WAPP_CONTACTS_SYNC_AUTHENTICATION = gql`
  mutation SetContactSyncAuthenticationForRegister($registerId: ID!, $authCode: String!, $redirectUri: String!) {
    setContactSyncAuthenticationForRegister(register_id: $registerId, auth_code: $authCode, redirect_uri: $redirectUri)
  }
`

export const MUTATION_DELETE_NUMBER = gql`
  mutation DeleteNumber($id: ID!) {
    deleteNumber(_id: $id)
  }
`

export const QUERY_MAX_NUMBER_OF_SENDERS = gql`
  query GetMaxNofSenders {
    getMaxNofSenders
  }
`

export const MUTATION_UPDATE_NUMBER_PUBLIC_INFORMATION = gql`
  mutation UpdateWappConfigNumber($data: WappConfigNumbersUpdateInput!) {
    updateWappConfigNumber(data: $data)
  }
`
